import { generateBFFUrl } from '@/configs/apiEndPoints';
import axiosInstance from '../axiosConfig';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import { ERROR } from '@/configs/constants';
import { ECOM_PRODUCTS_DETAIL } from '@/configs/ecom/apis';
import dlv from 'dlv';

export const getProductsDetail = async (params: any): Promise<any> => {
  try {
    const response = await axiosInstance.get(generateBFFUrl(ECOM_PRODUCTS_DETAIL), {
      params,
    });
    return dlv(response, 'data.data', []);
  } catch (error: any) {
    console.error(error?.message);
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};
